/// <amd-module name="SuiteCommerce.Blog.Pagination.Button.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.Pagination.Button.View", ["require", "exports", "Backbone", "sc_blog_pagination_button.tpl"], function (require, exports, Backbone_1, buttonTemplate) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.PaginationButtonView = void 0;
    var PaginationButtonView = /** @class */ (function (_super) {
        __extends(PaginationButtonView, _super);
        function PaginationButtonView(options) {
            var _this = _super.call(this, options) || this;
            _this.template = buttonTemplate;
            _this.events = {
                'click [data-action="trigger-pagination"]': 'triggerPagination',
            };
            if (options.isEnabledEventsHandling)
                _this.isEnabledEventsHandling = options.isEnabledEventsHandling;
            if (options.paginationEventId)
                _this.paginationEventId = options.paginationEventId;
            return _this;
        }
        PaginationButtonView.prototype.triggerPagination = function (event) {
            event.preventDefault();
            var page = parseInt(event.target.getAttribute('data-page'), 10);
            this.model.trigger(this.paginationEventId, { page: page });
            return false;
        };
        PaginationButtonView.prototype.getContext = function () {
            return {
                label: this.model.label,
                url: this.model.url,
                isActive: this.model.isActive,
                isEnabledEventsHandling: this.isEnabledEventsHandling,
                pageNumber: this.model.pageNumber,
                hideDivider: this.model.hideDivider,
            };
        };
        return PaginationButtonView;
    }(Backbone_1.View));
    exports.PaginationButtonView = PaginationButtonView;
});
